export interface Font {
    id: string,
    technicalName: string,
    displayName: string,
    status: FontStatusEnum,
    hasFile: boolean;
    type: string;
}

export enum FontStatusEnum {
    Active = 1,
    Disabled = 0
}
